import { render, staticRenderFns } from "./News4.vue?vue&type=template&id=f9ab3ed4&scoped=true&"
import script from "./News4.vue?vue&type=script&lang=ts&"
export * from "./News4.vue?vue&type=script&lang=ts&"
import style0 from "./News4.vue?vue&type=style&index=0&id=f9ab3ed4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ab3ed4",
  null
  
)

export default component.exports